var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmailFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 395 395",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M395 320.089V74.911L258.806 197.5zM197.5 252.682l-38.884-35L22.421 340.271h350.158L236.384 217.682zM372.579 54.729H22.421L197.5 212.318zM0 74.911v245.178L136.194 197.5z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailFilled);
export default __webpack_public_path__ + "static/media/EmailFilled.16eb66fe.svg";
export { ForwardRef as ReactComponent };